export const cursor = {
  DEFAULT: 'default',
  POINTER: 'pointer'
} as const

export type CursorKeyType = (typeof cursor)[keyof typeof cursor]
